import React, { Component } from 'react';
import Error404 from '@/app/components/Error404';

export default class Notfound extends Component {
  render() {
    return <Error404 />;
  }
}
